const getters = {
    loginHint: state => state.loginHint,
    flashMessages: state => state.flash.current,
    leftDrawerOpen: state => state.navigation.leftDrawerOpen,
    rightDrawerOpen: state => state.navigation.rightDrawerOpen,
    rightRailOpen: state => state.navigation.rightRailOpen,
    watchlist: state => state.watchlist,
    activityDetails: state => {
        if (state.rightDrawerContent?.type === 'activity') {
            return state.rightDrawerContent.item
        }
        return null
    },
    rightDrawerContent: state => state.rightDrawerContent,
    currentEntity: state => state.currentEntity,
    popover: state => state.popover,
    countries: state => state.geography.countries,
    exchanges: state => state.markets.exchanges,
    customWork: state => state.customWork,
    jobRoles: state => state.jobRoles,
    searchModal: state => state.searchModal,
    profiles: state => state.profiles,
    proxyCompensation: state => state.proxyCompensation,
    currentTaskItem: state => {
        if (state.rightDrawerContent?.type === 'task-item') {
            return state.rightDrawerContent.item
        }

        return null
    },
    features: state => state.features,
}

export default getters
